import React from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

const StyledMenu = (props) => {
  const menuProps = {
    anchorEl: props.anchorEl ? props.anchorEl : null,
    open: props.open,
    onClose: props.onClose,
  }
  return (
    <Menu {...menuProps}>
      {props.menuItems.map((item) => {
        return <MenuItem onClick={item.onClick}>{item.displayText}</MenuItem>
      })}
    </Menu>
  )
}

export default StyledMenu
